import { HttpRequest } from './HttpRequest'

export const GetReportInspectionPlanning = async (objectSearch: any) => {
    let data = JSON.stringify(objectSearch)
    try {
        const response = await HttpRequest().post(`/report/inspectionplanning`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error) {
        throw error
    }
}

export const GetReportBankCreditExcel = async (objectSearch: any) => {
    let data = JSON.stringify(objectSearch)
    try {
        const response = await HttpRequest().post(`/report/bankcredit-excel`, data, {
            headers: {
                'Content-Type': 'application/json'
            },
            responseType: 'blob'
        })
        return response.data
    } catch (error) {
        throw error
    }
}

export const GetReportBankCredit = async (objectSearch: any) => {
    let data = JSON.stringify(objectSearch)
    try {
        const response = await HttpRequest().post(`/report/bankcredit`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error) {
        throw error
    }
}

export const GetTrackingTransfer = async (objectDeedProspect: any) => {
    let data = JSON.stringify(objectDeedProspect);
    try {
        const response = await HttpRequest().post(`/report/trackingtransfer`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error) {
        throw error
    }
}

export const GetReportHeirachy = async (objectDeedProspect: any) => {
    let data = JSON.stringify(objectDeedProspect);
    try {
        const response = await HttpRequest().post(`/report/heirachy`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error) {
        throw error
    }
}

export const GetReportEmailTransfer = async (object: any) => {
    let data = JSON.stringify(object);
    try {
        const response = await HttpRequest().post(`/viewdata/emailTransfer`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error) {
        throw error
    }
}

export const GetTransferPlanTotalSummaryDetail = async (object: any) => {
    let data = JSON.stringify(object);
    try {
        const response = await HttpRequest().post(`/report/transferPlanTotalSummaryDetail`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error) {
        throw error
    }
}

export const GetTransferplanEmailAlertSummaryTransfer = async (object: any) => {
    let data = JSON.stringify(object);
    try {
        const response = await HttpRequest().post(`/viewdata/emailalertsummarytransfer`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error) {
        throw error
    }
}

